import React, { useCallback, useState } from 'react';
import { Button } from 'antd';
import { useDropzone } from 'react-dropzone';
import UserAvatar from './common/UserAvatar';
import { getBase64 } from '../util/files';

const ChooseAvatar = ({
  onCancel,
  onComplete,
}: {
  onCancel: () => void;
  onComplete: (base64String: string | null) => void;
}) => {
  const [tempAvatar, setTempAvatar] = useState<string | null>(null);

  const onDrop = useCallback(async (acceptedFiles) => {
    const base64 = await getBase64(acceptedFiles[0]);
    setTempAvatar(base64);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: 'image/jpeg, image/png',
  });

  return (
    <>
      <div className='onboarding-title'>this is your avatar</div>
      <div className='onboarding-subtitle'>
        this is what people will see when they enter the party...
      </div>
      <div className='onboarding-avatar'>
        <UserAvatar size={128} src={tempAvatar} />
      </div>
      <div className='onboarding-actions-group file-upload'>
        {/* <Upload
          customRequest={async (options) => {
            options.onProgress({ percent: 0 }, options.file);
            console.log(options.file);
            // const url = Promise.resolve('https://ant.design');
            options.onProgress({ percent: 100 }, options.file);
            options.onSuccess({}, options.file);
          }}
          style={{ width: '100%' }}
          onChange={async (info) => {
            if (info.file.status === 'uploading') {
              setLoading(true);
              return;
            }

            console.log(info.file);

            if (info.file.status === 'done') {
              // Get this url from response in real world.
              const imageUrl = await getBase64(info.file.originFileObj as Blob);
              console.log(imageUrl);
              setLoading(true);
              setTempAvatar(imageUrl);
            }
          }}> */}
        <div style={{ width: '100%' }} {...getRootProps()}>
          <input {...getInputProps()} />
          <Button
            onClick={() => {}}
            className='cta'
            style={{ width: '100%', height: 80, border: 'none' }}
            size='large'>
            {isDragActive ? 'drop file here' : 'drag file or click to upload'}
          </Button>
        </div>
      </div>
      <div className='onboarding-actions-group' style={{ marginTop: 60 }}>
        <Button
          type='dashed'
          style={{ width: '48%', height: 80 }}
          size='large'
          onClick={() => {
            onCancel();
          }}>
          cancel
        </Button>
        <Button
          onClick={() => {
            onComplete(tempAvatar);
          }}
          type='primary'
          style={{ width: '48%', height: 80 }}
          size='large'
          disabled={!tempAvatar}>
          accept
        </Button>
      </div>
    </>
  );
};

export default ChooseAvatar;
